import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './Container.css';

const Container = ({
  showRightSidebar,
  ...props
}) => {
  const classes = classnames({
    'kt-messaging-container': true,
    'kt-messaging-container-expanded': showRightSidebar
  });
  return (
    <div className={classes}>
      { props.children }
    </div>
  );
};

Container.propTypes = {
  showRightSidebar: PropTypes.bool
};

Container.defaultProps = {
  showRightSidebar: false
};

export default Container;
